var styleDataHash = "1618ec2b";
const injectCss = () => {
  var css = `.UB9Ns{display:grid;gap:12px var(--ricos-color-picker-color-swatch-gap,21.6px);grid-template-columns:repeat(6,minmax(0,1fr))}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var new_color_swatches_default = {
  "container": "UB9Ns"
};
export {
  new_color_swatches_default as default,
  injectCss
};
//# sourceMappingURL=new-color-swatches-scss.js.map
